$(document).ready(function () {
  // Select all elements with class "elementWithClass"
  const elementsWithClass = $(".left-text-title");

  elementsWithClass.each(function () {
    // Check if the current element has the class "elementWithClass"
    if ($(this).hasClass("lefttext")) {
      // Add the class "newClass" to the parent div
      $(this).parent().parent().addClass("advantages-uses-add");
    }
  });
});


$(document).ready(function () {
$(".dropdown-toggle-two").click(function(){
  $(".dropdown-menu-two").toggleClass("langopen");
});

$(".dropdown-toggle-one").click(function(){
  $(".dropdown-menu-one").toggleClass("langopen");
});
  
});  


$(document).ready(function () {
  if ($(window).width() < 1024) {
  $(".navmenu-depth-3 .navmenu-link").click(function(event) {                
                event.preventDefault();
                var href = $(this).attr("href");
               window.location.href = href;
     setTimeout(function() {
                    window.location.reload();
                }, 500); 
            });
    }
});  

window.addEventListener('scroll', function () {
  const triggerEl = document.querySelector('.bcontact-field__html');
  const otherEl = document.querySelector('.application-title'); // Replace with actual selector
  const targetEl = document.querySelector('.bcontact-field.bcontact-field--image-choice');
  const targetE2 = document.querySelector('.bcontact-field__Select-The-Tool-Style');

  // Check all required elements exist
  if (!triggerEl || !otherEl || !targetEl || !targetE2) return;

  const triggerOffset = triggerEl.getBoundingClientRect().top;
  const otherOffset = otherEl.getBoundingClientRect().top;

  if (triggerOffset <= 150 && otherOffset > 150) {
    targetEl.classList.add('sticky');
    targetE2.classList.add('sticky');
  } else {
    targetEl.classList.remove('sticky');
    targetE2.classList.remove('sticky');
  }
}); 


